import { useEffect, useState } from "react";
import useSelect from "~components/Form/hooks/useSelect";

const useTipoPessoa = (setTipoPessoaStatus, config = {}) => {
  const { salvarLocalStorage = false, chave } = config;

  const tipoPessoaSelect = useSelect("tipoPessoa");
  const [tipo, setTipo] = useState(0); // 0 = todos
  const [fila, setFila] = useState(null);

  const optionsTipoPessoa = [
    { value: 0, label: "Todos" },
    { value: 2, label: "RECEBEDOR" },
    { value: 1, label: "EMISSOR/RECEBEDOR" },
    { value: 3, label: "PROSPECT" },
  ];

  function onChangeTipo(option) {
    tipoPessoaSelect.upDateValue(option?.value);
    tipoPessoaSelect.upDateDefaultValue(option || "");
    setTipo(option?.value ?? 0);

    if (salvarLocalStorage && chave) {
      localStorage.setItem(chave, JSON.stringify(option));
    }
  }

  function CleanForFilter(option) {
    onChangeTipo(option);
  }

  useEffect(() => {
    if (salvarLocalStorage && chave) {
      const salvo = localStorage.getItem(chave);
      try {
        if (salvo && salvo !== "undefined") {
          const obj = JSON.parse(salvo);
          setTipo(obj?.value ?? 0);
          onChangeTipo(obj);
          setFila(obj?.value ?? null);
        }
      } catch (e) {
        console.warn("Erro ao carregar tipoPessoa do localStorage:", e);
      }
    }
  }, []);

  function SetSelectTipoPessoa(id) {
    const option = optionsTipoPessoa.find((o) => o.value === id);
    if (option) {
      onChangeTipo(option);
      setFila(null);
    } else {
      setFila(id);
    }
  }

  useEffect(() => {
    if (fila !== null) {
      SetSelectTipoPessoa(fila);
    }
  }, [optionsTipoPessoa]);


  useEffect(() => {
    setTipoPessoaStatus(tipo);
  }, [tipo]);

  return {
    tipo,
    optionsTipoPessoa,
    tipoPessoaSelect,
    onChangeTipo,
    SetSelectTipoPessoa,
    CleanForFilter,
  };
};

export default useTipoPessoa;
